// Property Form Constants - Extracted from PropertyForm.js for better maintainability

export const AMENITIES_OPTIONS = [
  "Swimming Pool", "Gym", "Club House", "Children's Play Area", "Jogging Track",
  "Indoor Games", "Sports Facility", "Party Hall", "Meditation Area", "Spa",
  "Shopping Center", "Restaurant", "24x7 Security", "CCTV Surveillance", "Intercom",
  "Fire Safety", "Visitor Parking", "Water Softener", "Rain Water Harvesting"
];

export const PROPERTY_FEATURES = [
  "Corner Property", "Gated Community", "Pet Friendly", "Servant Room",
  "Study Room", "Store Room", "Puja Room", "Vastu Compliant",
  "Wheelchair Friendly", "Modular Kitchen", "Private Garden", "Private Pool"
];

// Property Subtypes by Category
export const PROPERTY_SUBTYPES = {
  residential: [
    { value: "apartment", label: "Apartment/Flat" },
    { value: "independent_house", label: "Independent House" },
    { value: "villa", label: "Villa" },
    { value: "bungalow", label: "Bungalow" },
    { value: "bungalow_scheme", label: "Bungalow Scheme" },
    { value: "twin_bungalow", label: "Twin Bungalow" },
    { value: "row_house", label: "Row House" },
    { value: "builder_floor", label: "Builder Floor" },
    { value: "penthouse", label: "Penthouse" },
    { value: "studio", label: "Studio Apartment" },
    { value: "residential_project", label: "Residential Project" },
    { value: "township", label: "Township" },
    { value: "standalone_building", label: "Standalone Building" },
    { value: "farmhouse", label: "Farm House" }
  ],
  commercial: [
    { value: "office_space", label: "Office Space" },
    { value: "shop", label: "Shop" },
    { value: "showroom", label: "Showroom" },
    { value: "commercial_building", label: "Commercial Building" },
    { value: "mall", label: "Mall/Shopping Center" },
    { value: "warehouse", label: "Warehouse/Godown" },
    { value: "industrial_shed", label: "Industrial Shed" },
    { value: "co_working", label: "Co-Working Space" },
    { value: "business_center", label: "Business Center" },
    { value: "it_park", label: "IT Park/SEZ" },
    { value: "hotel", label: "Hotel/Resort" },
    { value: "lodge", label: "Lodge/Guest House" },
    { value: "co_living", label: "Co-Living Space" },
    { value: "restaurant", label: "Restaurant/Cafe Space" }
  ],
  land: [
    { value: "residential_plot", label: "Residential Plot" },
    { value: "commercial_plot", label: "Commercial Plot" },
    { value: "industrial_plot", label: "Industrial Plot" },
    { value: "plotting_scheme", label: "Plotting Scheme" },
    { value: "agricultural_land", label: "Agricultural Land" },
    { value: "farm_land", label: "Farm Land" },
    { value: "na_plot", label: "NA Plot" },
    { value: "institutional_land", label: "Institutional Land" }
  ],
  mixed: [
    { value: "mixed_use_development", label: "Mixed Use Development" },
    { value: "residential_commercial", label: "Residential-Commercial Complex" },
    { value: "mixed_use_tower", label: "Mixed Use Tower" },
    { value: "retail_residential", label: "Retail + Residential" },
    { value: "office_residential", label: "Office + Residential" },
    { value: "commercial_retail", label: "Commercial + Retail" },
    { value: "mixed_use_plaza", label: "Mixed Use Plaza" }
  ]
};

export const ROOM_TYPES = [
  "Bedroom", "Master Bedroom", "Parents Room", "Children Bedroom",
  "Living Room", "Hall", "Kitchen", "Balcony", "Dry Balcony", "Bathroom",
  "Kids Room", "Pooja Room", "Servant Room", "Powder Room",
  "Dining Room", "Study Room", "Store Room", "Terrace", "Garden",
  "Drawing Room", "Lobby", "Passage", "Utility Room", "Other"
];

// Room types for commercial/office properties - Dynamic based on subtype
export const COMMERCIAL_SPACE_TYPES = {
  office_space: [
    "Reception Area", "Conference Room", "Meeting Room", "Server Room",
    "MD Cabin", "Director Cabin", "GM Cabin", "Manager Cabin", "Team Lead Cabin",
    "Workstation Area", "Pantry/Cafeteria", "Washroom", "Store Room",
    "Waiting Area", "Board Room", "Training Room", "HR Cabin", "Finance Cabin",
    "IT Room", "Record Room", "Utility Room"
  ],
  shop: [
    "Main Shop Area", "Display Area", "Storage Room", "Trial Room",
    "Counter Area", "Backroom", "Washroom", "Staff Room"
  ],
  showroom: [
    "Main Display Area", "Front Display Window", "Customer Seating Area",
    "Product Demo Area", "Storage Room", "Manager Cabin", "Washroom",
    "Reception/Counter", "VIP Lounge", "Staff Room"
  ],
  warehouse: [
    "Main Storage Area", "Loading Bay", "Dispatch Area", "Quality Check Area",
    "Office Space", "Security Room", "Washroom", "Utility Room",
    "Cold Storage Area", "Packaging Area"
  ],
  industrial_shed: [
    "Production Floor", "Assembly Area", "Quality Control Area", "Raw Material Storage",
    "Finished Goods Storage", "Office Section", "Staff Room", "Washroom",
    "Utility Room", "Loading/Unloading Bay"
  ],
  co_working: [
    "Hot Desk Area", "Dedicated Desk Area", "Private Cabin", "Meeting Room",
    "Conference Room", "Phone Booth", "Collaboration Zone", "Cafeteria/Pantry",
    "Relaxation Area", "Reception", "Server Room", "Washroom"
  ],
  business_center: [
    "Reception Area", "Executive Office", "Standard Office", "Meeting Room",
    "Conference Room", "Pantry", "Server Room", "Washroom", "Waiting Area"
  ],
  it_park: [
    "Development Floor", "Testing Lab", "Server Room", "Conference Room",
    "Meeting Room", "Training Room", "Cafeteria", "Recreation Area",
    "HR Department", "Admin Office", "Reception", "Washroom"
  ],
  hotel: [
    "Standard Room", "Deluxe Room", "Suite", "Presidential Suite",
    "Lobby Area", "Reception", "Restaurant Area", "Bar/Lounge",
    "Banquet Hall", "Conference Room", "Swimming Pool Area", "Spa/Wellness Area",
    "Gym/Fitness Center", "Kitchen", "Back Office", "Staff Room", "Laundry Room"
  ],
  restaurant: [
    "Main Dining Area", "Private Dining Room", "Bar Area", "Kitchen",
    "Prep Kitchen", "Cold Storage", "Outdoor Seating", "Terrace Area",
    "Reception/Waiting", "Washroom", "Staff Room", "Store Room"
  ],
  mall: [
    "Anchor Store Space", "Inline Shop", "Food Court", "Multiplex Area",
    "Gaming Zone", "Kids Play Area", "Common Area/Atrium", "Parking Area",
    "Admin Office", "Security Room", "Utility Area"
  ],
  lodge: [
    "Single Room", "Double Room", "Family Room", "Dormitory",
    "Reception", "Common Sitting Area", "Dining Area", "Kitchen",
    "Washroom (Common)", "Manager Room", "Storage Room"
  ],
  co_living: [
    "Single Occupancy Room", "Twin Sharing Room", "Triple Sharing Room",
    "Common Living Area", "Shared Kitchen", "Dining Area", "Study Room",
    "Laundry Room", "Recreation Room", "Rooftop/Terrace", "Washroom"
  ]
};

// Default office room types (legacy compatibility)
export const OFFICE_ROOM_TYPES = COMMERCIAL_SPACE_TYPES.office_space;

export const MEASUREMENT_UNITS = [
  { value: "sq_ft", label: "sq ft" },
  { value: "sq_m", label: "sq m" }
];

// Dynamic field configuration based on property type
export const SPEC_FIELDS_CONFIG = {
  residential: {
    common: ['area', 'built_up_area', 'super_built_up_area', 'furnishing', 'parking', 'facing', 'age_of_property', 'possession_status', 'flooring_type', 'water_supply', 'power_backup', 'security'],
    apartment: ['bedrooms', 'bathrooms', 'balconies', 'floor_number', 'total_floors', 'lift_available', 'parking', 'parking_type', 'furnishing', 'overlooking', 'room_sizes'],
    independent_house: ['bedrooms', 'bathrooms', 'balconies', 'total_floors', 'parking', 'parking_type', 'furnishing', 'room_sizes'],
    villa: ['bedrooms', 'bathrooms', 'balconies', 'total_floors', 'parking', 'parking_type', 'furnishing', 'room_sizes'],
    bungalow: ['bedrooms', 'bathrooms', 'balconies', 'total_floors', 'parking', 'parking_type', 'furnishing', 'room_sizes'],
    bungalow_scheme: ['bedrooms', 'bathrooms', 'balconies', 'total_floors', 'parking', 'parking_type', 'furnishing', 'room_sizes'],
    twin_bungalow: ['bedrooms', 'bathrooms', 'balconies', 'total_floors', 'parking', 'parking_type', 'furnishing', 'room_sizes'],
    builder_floor: ['bedrooms', 'bathrooms', 'balconies', 'floor_number', 'total_floors', 'parking', 'furnishing', 'room_sizes'],
    penthouse: ['bedrooms', 'bathrooms', 'balconies', 'floor_number', 'total_floors', 'lift_available', 'parking', 'furnishing', 'overlooking', 'room_sizes'],
    studio: ['bathrooms', 'floor_number', 'total_floors', 'lift_available', 'parking', 'furnishing'],
    farmhouse: ['bedrooms', 'bathrooms', 'parking', 'furnishing', 'room_sizes'],
    row_house: ['bedrooms', 'bathrooms', 'balconies', 'total_floors', 'parking', 'furnishing', 'room_sizes'],
  },
  commercial: {
    common: ['area', 'built_up_area', 'furnishing', 'parking', 'facing', 'age_of_property', 'possession_status', 'power_backup', 'lift_available', 'security'],
    office_space: ['floor_number', 'total_floors', 'lift_available', 'parking', 'parking_type', 'furnishing', 'power_backup', 'office_rooms', 'total_cabins', 'workstations', 'washrooms'],
    shop: ['floor_number', 'total_floors', 'parking', 'furnishing', 'frontage_width', 'ceiling_height'],
    showroom: ['floor_number', 'total_floors', 'parking', 'parking_type', 'furnishing', 'power_backup', 'frontage_width', 'ceiling_height', 'display_windows'],
    warehouse: ['total_floors', 'parking', 'parking_type', 'power_backup', 'loading_docks', 'ceiling_height', 'floor_strength', 'floor_plate_area', 'total_carpet_area', 'total_saleable_area'],
    industrial_shed: ['total_floors', 'parking', 'power_backup', 'ceiling_height', 'floor_strength', 'crane_facility', 'floor_plate_area', 'total_carpet_area', 'total_saleable_area'],
    co_working: ['floor_number', 'total_floors', 'lift_available', 'parking', 'furnishing', 'power_backup', 'total_seats', 'meeting_rooms', 'conference_rooms'],
    business_center: ['floor_number', 'total_floors', 'lift_available', 'parking', 'furnishing', 'power_backup', 'office_rooms'],
    it_park: ['floor_number', 'total_floors', 'lift_available', 'parking', 'parking_type', 'power_backup', 'office_rooms', 'server_room', 'floor_plate_area', 'total_carpet_area', 'total_saleable_area'],
    commercial_building: ['total_floors', 'lift_available', 'parking', 'parking_type', 'power_backup', 'floor_plate_area', 'total_carpet_area', 'total_saleable_area'],
    mall: ['total_floors', 'lift_available', 'escalator_available', 'parking', 'parking_type', 'power_backup', 'floor_plate_area', 'total_carpet_area', 'total_saleable_area'],
    hotel: ['total_floors', 'lift_available', 'parking', 'parking_type', 'furnishing', 'power_backup', 'total_rooms', 'banquet_halls', 'restaurant_area'],
    lodge: ['total_floors', 'lift_available', 'parking', 'furnishing', 'power_backup', 'total_rooms'],
    co_living: ['total_floors', 'lift_available', 'parking', 'furnishing', 'power_backup', 'total_rooms', 'total_beds'],
    restaurant: ['floor_number', 'parking', 'furnishing', 'seating_capacity', 'kitchen_area', 'outdoor_seating'],
  },
  land: {
    common: ['plot_dimensions', 'facing', 'boundary_wall', 'corner_plot', 'road_width', 'road_facing', 'zone_type'],
    residential_plot: ['plot_dimensions', 'boundary_wall', 'corner_plot'],
    commercial_plot: ['plot_dimensions', 'boundary_wall', 'corner_plot', 'fsi'],
    industrial_plot: ['plot_dimensions', 'boundary_wall', 'fsi', 'zone_type'],
    agricultural_land: ['plot_dimensions', 'water_source', 'existing_crops', 'soil_type'],
    farm_land: ['plot_dimensions', 'water_source', 'farmhouse_exists', 'existing_crops'],
    na_plot: ['plot_dimensions', 'boundary_wall', 'na_order_date'],
    institutional_land: ['plot_dimensions', 'zone_type', 'fsi']
  },
  mixed: {
    common: ['area', 'built_up_area', 'super_built_up_area', 'furnishing', 'parking', 'parking_type', 'facing', 'age_of_property', 'possession_status', 'power_backup', 'lift_available', 'security', 'total_floors'],
    mixed_use_development: ['total_floors', 'lift_available', 'parking', 'parking_type', 'power_backup', 'floor_plate_area', 'total_carpet_area', 'total_saleable_area'],
    residential_commercial: ['bedrooms', 'bathrooms', 'total_floors', 'lift_available', 'parking', 'parking_type', 'power_backup', 'floor_plate_area', 'total_carpet_area', 'total_saleable_area'],
    mixed_use_tower: ['total_floors', 'lift_available', 'parking', 'parking_type', 'power_backup', 'floor_plate_area', 'total_carpet_area', 'total_saleable_area'],
    retail_residential: ['bedrooms', 'bathrooms', 'total_floors', 'lift_available', 'parking', 'parking_type', 'furnishing', 'power_backup'],
    office_residential: ['bedrooms', 'bathrooms', 'total_floors', 'lift_available', 'parking', 'parking_type', 'furnishing', 'power_backup', 'office_rooms'],
    commercial_retail: ['total_floors', 'lift_available', 'parking', 'parking_type', 'furnishing', 'power_backup', 'frontage_width'],
    mixed_use_plaza: ['total_floors', 'lift_available', 'parking', 'parking_type', 'power_backup', 'floor_plate_area', 'total_carpet_area', 'total_saleable_area']
  }
};

// Check if a field should be shown based on property type and subtype
export const shouldShowField = (fieldName, propertyType, propertySubtype) => {
  const config = SPEC_FIELDS_CONFIG[propertyType];
  if (!config) return false;
  
  const commonFields = config.common || [];
  const subtypeFields = config[propertySubtype] || [];
  
  return commonFields.includes(fieldName) || subtypeFields.includes(fieldName);
};

// Furnishing types
export const FURNISHING_TYPES = [
  { value: "fully_furnished", label: "Fully Furnished" },
  { value: "semi_furnished", label: "Semi-Furnished" },
  { value: "unfurnished", label: "Unfurnished" },
  { value: "bare_shell", label: "Bare Shell" },
  { value: "warm_shell", label: "Warm Shell" }
];

// Upload limits
export const MAX_IMAGES = 4;
export const MAX_VIDEOS = 1;
export const MAX_IMAGE_SIZE_MB = 5;
export const MAX_VIDEO_SIZE_MB = 10;
export const MAX_VIDEO_DURATION_SEC = 30;

// Form tabs configuration
export const FORM_TABS = [
  { id: 'basic', label: 'Basic Details', step: 1 },
  { id: 'specifications', label: 'Specifications', step: 2 },
  { id: 'measurements', label: 'Sizes', step: 3 },
  { id: 'amenities', label: 'Amenities & Features', step: 4 },
  { id: 'legal', label: 'Legal & Pricing', step: 5 },
  { id: 'media', label: 'Media & Plans', step: 6 },
  { id: 'insights', label: 'AI Insights', step: 7 }
];

// Initial form data state
export const getInitialFormData = () => ({
  title: "",
  description: "",
  property_type: "residential",
  property_subtype: "",
  purpose: "sale",
  price: "",
  location: "",
  locality: "",
  city: "",
  state: "",
  landmark: "",
  address: "",
  pincode: "",
  area: "",
  built_up_area: "",
  super_built_up_area: "",
  bedrooms: "",
  bathrooms: "",
  balconies: "",
  furnishing: "",
  furnishing_type: "",
  furnishing_details: "",
  parking: "",
  parking_type: "",
  floor_number: "",
  total_floors: "",
  facing: "",
  overlooking: "",
  age_of_property: "",
  possession_status: "",
  possession_date: "",
  flooring_type: "",
  water_supply: "",
  power_backup: "",
  security: "",
  transaction_type: "",
  ownership_type: "",
  approved_by: [],
  rera_registered: false,
  rera_id: "",
  maintenance_charges: "",
  booking_amount: "",
  amenities: [],
  features: [],
  youtube_url: "",
  room_measurements: [],
  office_room_measurements: [],
  plot_dimensions: { length: "", width: "", area: "", unit: "sq_ft" },
  project_name: "",
  builder_name: "",
  total_units: "",
  available_units: "",
  rate_amount: "",
  rate: "",
  all_inclusive_price: "",
  agreement_value: "",
  maintenance_per_sqft: "",
  corpus_fund: "",
  infrastructure_cost: "",
  stamp_duty_percent: "7",
  gst_percent: "",
  total_cabins: "",
  workstations: "",
  washrooms: "",
  conference_rooms: "",
  meeting_rooms: "",
  total_seats: "",
  loading_docks: "",
  ceiling_height: "",
  floor_strength: "",
  frontage_width: "",
  display_windows: "",
  seating_capacity: "",
  kitchen_area: "",
  outdoor_seating: false,
  total_rooms: "",
  banquet_halls: "",
  restaurant_area: "",
  water_source: "",
  existing_crops: "",
  soil_type: "",
  farmhouse_exists: false,
  boundary_wall: false,
  corner_plot: false,
  road_width: "",
  road_facing: "",
  zone_type: "",
  fsi: "",
  na_order_date: "",
  existing_loan_amount: "",
  financial_institute_name: "",
  lift_available: false,
  number_of_lifts: "",
  lift_type: "",
  escalator_available: false,
  status: "available",
  // Rental/Lease specific fields
  monthly_rent: "",
  rent_type: "lumpsum",
  rent_per_sqft_carpet: "",
  rent_per_sqft_builtup: "",
  rent_sqft_type: "carpet",
  security_deposit: "",
  security_deposit_type: "lumpsum",
  security_deposit_months: "",
  lock_in_period: "",
  lease_duration: "",
  rent_escalation: "",
  maintenance_included: false,
  electricity_included: false,
  water_included: false,
  rent_negotiable: false,
  preferred_tenant: "",
  available_from: "",
  total_beds: "",
});
